import { ChangesListPage } from "@/components/changes-list";
import { ReviewStage } from "@/components/review-stage";
import { useParams } from "react-router-dom";

export function ReviewsPage() {
  const { reviewId } = useParams();
  if (reviewId) return <ReviewStage key={reviewId} />;
  return <ChangesListPage />;
}
